<template>
 <div class="card">
     <div class="card-body text-center py-5 mb-5">
        <div class="mt-5 mb-3">
            <img src="@/assets/global_assets/images/page_not_found.png" class="" alt="">
        </div>
        <h1 class="error-page-title">Page Not Found!</h1>
        <div class="error-page-text">
            We’re sorry, the page you requested could not be found. Please go back<br>
to the homepage or contact us at support@goship.com
<br><br>
Request Id: Af568fewfqwr85dads2caadwdwrt
        </div>
        <div class="mt-4">
            <button class="btn btn-lg btn-primary" ><i class="fas fa-arrow-alt-circle-left mr-2"></i>Go Back</button>
        </div>
    </div>
 </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {

        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/central/account/PageNotFound.vue